import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import DataStreams from './pages/DataStreams';
import Initiatives from './pages/Initiatives';
import Reports from './pages/Reports';
import DemoPage from './pages/DemoPage';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="streams" element={<DataStreams />} />
          <Route path="initiatives" element={<Initiatives />} />
          <Route path="reports" element={<Reports />} />
          <Route path="demo" element={<DemoPage />} />
          <Route path="settings" element={
            <div className="flex items-center justify-center h-full text-slate-500 text-sm font-mono">
              [SYSTEM_MESSAGE]: Settings module restricted to Admin users.
            </div>
          } />
        </Route>
      </Routes>
    </HashRouter>
  );
}